<template>
	<div>
		<perview-file v-if="isFilePriview" v-bind:file="filePriviewData" @closePopup="closePopup" ></perview-file>
			<div class="container container--narrow pdt-50">
				<div class="t-headline11 font-m l-spacing72 t-line-h-36">
					{{name}}
				</div>
			<div class="mdc-card mgt-24">
				<div class="pda-24">
				<div class="mgb-16 t-headline7 font-m l-spacing72 t-line-h-36"> {{ $t("3468") }} </div>
					<div class="t-body1 t-color-bodyGrayA t-line-h-26 l-spacing48 mgt-8 font-r">
						{{description}}
					</div>
				</div>
			</div>
			<div v-if="reference.length" class="mdc-card mgt-24">
				<div class="pda-24">
					<div class="mgb-16 t-headline7 font-m l-spacing72 t-line-h-36">{{$t('123')}} </div>
					<div
					v-for="(file, index) in reference"
					:key="index" class="d-flex align-items-center justify-content-between pdt-3 pdb-2 bg-whiteBorder b-radius4"
					@click="donwloadFile(file)">
						<div class="d-flex align-items-center flex-grow-1">
								<i class="material-icons t-color-secondaryBtnText font16">attach_file</i>
								<span class="t-color-signBlue t-body1 font-r pdl-16">{{file.originalName}}</span>
						</div>
						<div>
							<button class="material-icons mdc-icon-button t-color-iconInactive mgr--12" tabindex="0"  @click="donwloadFile(updateFileFormat(file))" @keypress="donwloadFile(updateFileFormat(file))">download</button>
						</div>
					</div>
				</div>
			</div>

			<div class="mdc-card mgt-24">
				<div class="pda-24">
				<div class="mgb-16 t-headline7 font-m l-spacing72 t-line-h-36"> {{$t('114')}}</div>
				<div class="d-flex flex-row justify-content-between align-content-center"> 
					<div class="t-body1 t-color-bodyGrayA t-line-h-26 l-spacing48 mgt-8 font-r">
						{{$t('124')}}
					</div>
					<div class="t-body1 t-color-bodyGrayA t-line-h-26 l-spacing48 mgt-8 font-r">
						{{ $moment(submissionDateStart).format('L')}} ~ {{ displayEndPeriod(submissionDateEnd) }}
					</div>
				</div>
				</div>
			</div>

			<div class="mgt-50 mgb-50">
				<button v-if="isSubmit" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 " tabindex="0"  @click="moveSubmit()" @keypress="moveSubmit()">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('125')}}</span>
				</button>
				<!-- <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 " @click="moveList()"  v-else tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('168')}}</span>
				</button> -->
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 나의 학습 상세 - 미션 상세 정보 컴포넌트(my learning view - mission view information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { fileMixin } from '@/mixins/file.js';
import { MDCRipple } from '@material/ripple';
import { videoPlayer } from "vue-video-player";
import PerviewFile from "@/components/board/PerviewFile";
import { utilDateMixin } from '@/mixins/dateUtil';

export default {
	props: ['name', 'description', 'reference', 'answer', 'eval', 'submissionDateStart', 'submissionDateEnd', 'status'],
	mixins: [fileMixin, utilDateMixin],
	data() {
		return {
			isFilePriview: false,
			filePriviewData: null
		}	
	},
	components: {
		videoPlayer,
		PerviewFile,
	},
	computed: {
		// 제출 상태(submit status)
		isSubmit() {
			return this.status === 'SUBMISSIBLE'
		},

		//  수정 상태(update status)
		isUpdate() {
			return !!this.answer && (this.status === 'SUBMITTED' || this.status === 'UNDER_EVALUATION' || this.status === 'REJECT')
		}
	},
	mounted() {
		this.setMaterialUi()
	},
	methods: {
		// 제출 이동(move submit)
		moveSubmit() {
			this.$router.push({
				name: 'LearnViewMissionSubmit',
				params: this.$route.params,
				query: this.$route.query
			})
		},

		// 목록 이동(move list)
		// moveList() {
		// 	this.$router.push({
		// 		name: 'LearnView',
		// 		params: {
		// 			learnId: this.$route.params.learnId,
		// 		},
		// 		query: this.$route.query
		// 	})
		// },

		updateFileFormat(file) {
			return {
				file: file
			}
		},
		
		donwloadFile(fileData) {
            const isPreview = this.isPreviewExt(fileData);
            if (isPreview) {
            localStorage.setItem("socialFile", JSON.stringify(fileData));
				this.isFilePriview = true;
				this.filePriviewData = fileData;
            } else {
                this.donwloadAttachment(fileData);
            }
        },
		
		closePopup() {
			this.isFilePriview = false;
		},

        isPreviewExt(fileData) {
            let previewExt = ["image", "video"];
            previewExt = previewExt.filter(
                (data) => fileData.contentType.indexOf(data) > -1
            );
            return previewExt.length > 0;
        },

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	},

}
</script>
<style scoped>
.bg-lectureYellow.h-13.pointline{
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    top: -8px;
    margin: 0 auto;
}
html[dir="rtl"] .bg-lectureYellow.h-13.pointline{
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
}
</style>